import React, { useEffect } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import ChatComponent from '../components/chat/ChatView';
import ChatViewMobile from '../components/chat/ChatViewMobile';
import useAuthStore from '../store/zustand/auth';
import useCompanyStore from '../store/zustand/company';
import useNavigationStore from '../store/zustand/navigation';

function ChatViewPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const userId = useAuthStore((state) => state.id);
  const company = useCompanyStore((state) => state.company);
  const preferredLanguage = useAuthStore((state) => state.preferredLanguage);
  const setIsPauseActive = useNavigationStore((s) => s.setIsPauseActive);

  // When a technician navigates to chat, ensure pause state is cleared
  // so the mobile sidebar remains accessible (isPauseActive hides MobileSidebar)
  useEffect(() => {
    setIsPauseActive(false);
  }, []);

  if (!userId) {
    return (
      <Box sx={{ p: 3 }}>
        <div>Loading user data...</div>
      </Box>
    );
  }

  const companyId = company?.id || 'default-company';

  // Use mobile layout on small screens
  if (isMobile) {
    return (
      <ChatViewMobile
        companyId={companyId}
        userId={userId}
        userLanguage={preferredLanguage || 'en'}
      />
    );
  }

  // Use desktop layout on large screens
  return (
    <ChatComponent
      companyId={companyId}
      userId={userId}
      userLanguage={preferredLanguage || 'en'}
    />
  );
}

export default ChatViewPage;
